import socket from "@/socket.js";

let timeout;

export default {
    bindEvents(context) {
        socket.on('connect', () => {
            console.log('connect');
        });
        socket.on('message:typing', (message) => {
            context.commit('typing', message.typing);
        });
        socket.on('message:create', (message) => {
            context.commit('receivedMessage', message);
        });
        socket.on('message:list', (messages) => {
            context.commit('fetchMessage', messages);
        });
    },
    startChat(context, payload) {
        context.commit('activeChat', payload)
        socket.emit('message:list', { userID: payload.user_id })
    },
    startTyping(context) {
        socket.emit('message:typing', { to: context.state.activeChat.user_id, typing: true })
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            socket.emit('message:typing', { to: context.state.activeChat.user_id, typing: false })
        }, 2000);
    },
    sendMessage(context, content) {
        socket.emit('message:create', { content: content, to: context.state.activeChat.user_id });
    }
}